import { DisplayConfig } from './types';

export const DEFAULT_DISPLAY_CONFIG: DisplayConfig = {
  480: 2,
  768: 3,
  1200: 4,
  max: 5,
};

export const DEFAULT_TIME = 600;
